import Vuex from "vuex";
import Vue from 'vue'

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        token: '',
        userInfo: {},
        routerMap: [],
    }
})

export {store}